import React, { createContext, useContext } from "react";

const ScopedDataLoadContext = createContext(null);
export const ScopedDataLoadProvider = ScopedDataLoadContext.Provider;
export const INITIAL_SCOPED_LOADING = Object.freeze({ status:"loading",failures:0,lastSuccessAt:null });
export const useScopedDataLoadState = () => useContext(ScopedDataLoadContext);
export const SCOPED_LOAD_FAILURE = "Não foi possível carregar, tentando novamente…";
export function ScopedLeadEmptyLabel({ fallback }) {
  const state = useScopedDataLoadState();
  if (!state || state.status === "ready") return fallback;
  return state.failures || state.error ? SCOPED_LOAD_FAILURE : "Carregando leads…";
}
export function ScopedLeadsUnavailable() {
  return <section role="status" aria-label="Carregamento de leads" style={{
    padding:"24px 16px",border:"1px solid #E8E1D3",borderRadius:12,
  }}>
    <h2 style={{ margin:"0 0 12px",fontSize:20 }}>Leads</h2>
    <ScopedLeadEmptyLabel fallback="Carregando leads…" />
  </section>;
}

export default function ScopedDataLoadNotice({ state, allStores, onRetry }) {
  if (!state || state.status === "ready"
    || (state.status === "loading" && !state.failures)) return null;
  return (
    <section role="alert" aria-label="Carregamento dos dados do CRM" style={{
      background: "#FFF7ED", border: "1px solid #FDBA74", borderRadius: 9,
      padding: "12px 14px", marginBottom: 14, color: "#9A3412", fontSize: 13,
    }}>
      <div style={{ fontWeight: 700 }}>{SCOPED_LOAD_FAILURE}</div>
      <div style={{ marginTop: 5 }}>
        {state.lastSuccessAt
          ? "Os dados exibidos são da última carga bem-sucedida e podem estar desatualizados."
          : "O carregamento não foi concluído; não é possível confirmar a quantidade de leads."}
        {" "}
        {state.status === "loading"
            ? "Tentando carregar novamente."
            : `Nova tentativa em ${state.nextDelayMs / 1000} segundos.`}
        {allStores && " Se preferir, consulte uma loja por vez."}
      </div>
      {state.status !== "loading" && <button type="button" onClick={onRetry} style={{
        marginTop: 9, padding: "7px 12px", border: "1px solid #9A3412",
        borderRadius: 6, color: "#9A3412", background: "#FFFFFF",
        cursor: "pointer", fontWeight: 600,
      }}>Tentar novamente</button>}
    </section>
  );
}
